import { render } from "./InitiatedRequests.vue?vue&type=template&id=6247fb6d&scoped=true"
import script from "./InitiatedRequests.vue?vue&type=script&lang=js"
export * from "./InitiatedRequests.vue?vue&type=script&lang=js"

import "./InitiatedRequests.vue?vue&type=style&index=0&id=6247fb6d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6247fb6d"

export default script